import { useEffect, useMemo } from 'react';
import { useRouteParams } from 'app/shared/hooks/useRouteParams';
import { useTranslation } from 'react-i18next';
import { useStyles } from './UpcomingDetailsModal.styles';
import { Modal } from '@mui/material';

import {
  ModalHeader,
  ModalVariant,
} from 'app/shared/components/generic-ui/ModalHeader/ModalHeader';

import {
  CircularProgress,
  ProgressType,
} from 'app/shared/components/generic-ui/CircularProgress';
import { UpcomingDetailsInfo } from './UpcomingDetailsInfo';
import { usePourEventsApi } from 'app/shared/hooks';

interface IUpcomingDetailsModal {
  isOpen: boolean;
  closeHandler: () => void;
  pourEventGID: string;
  header: string;
}

export const UpcomingDetailsModal = ({
  isOpen,
  closeHandler,
  pourEventGID,
  header,
}: IUpcomingDetailsModal) => {
  const { classes } = useStyles();

  const { id, organizationId }: { id: string; organizationId: string } =
    useRouteParams();

  const queryParams = useMemo(() => {
    return {
      organizationId: organizationId,
      queryParameters: {
        projectId: id,
        pourEventGID: pourEventGID,
      },
    };
  }, [id, organizationId, pourEventGID]);

  const {
    fetchUpcomingPourEvent,
    upcomingPourEventResponse,
    fetchUpcomingPourEventError,
  } = usePourEventsApi(queryParams);

  useEffect(() => {
    fetchUpcomingPourEvent();
  }, [fetchUpcomingPourEvent, pourEventGID]);

  useEffect(() => {
    if (fetchUpcomingPourEventError && isOpen) {
      closeHandler();
    }
  }, [closeHandler, fetchUpcomingPourEventError, isOpen]);

  const modalHeader = useMemo(() => {
    return header;
  }, [header]);

  return (
    <Modal
      open={isOpen}
      onClose={reason => {
        if (reason === 'backdropClick') {
          return false;
        }
        closeHandler();
      }}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      className={classes.modal}
    >
      <div className={classes.wrapper}>
        {upcomingPourEventResponse?.data ? (
          <div className={classes.container}>
            <ModalHeader
              header={modalHeader}
              closeHandler={closeHandler}
              variant={ModalVariant.SMALL}
            />

            <UpcomingDetailsInfo
              upcomingPourEvent={upcomingPourEventResponse?.data}
            />
          </div>
        ) : (
          <div className={classes.loading}>
            <CircularProgress withLabel size={40} type={ProgressType.LIGHT} />
          </div>
        )}
      </div>
    </Modal>
  );
};
